import axios from "axios";
import {STS} from "aws-sdk";
import moment from "moment";
import {getIamRoleArn} from "src/api/ApiConfig";
import TemporaryCredentials from "src/model/TemporaryCredentials";

let stsClient: STS;
// Temporary credentials retrieved by assuming role
let credentials: any = undefined;

// Return temporary credentials in the required format for signing the API request
export async function getCredentials(sts: STS): Promise<TemporaryCredentials> {
    stsClient = sts;
    // Retrieve credentials on initial call and keep refreshing periodically
    if (credentials === undefined) {
        await refreshCredentials();
        // Wait for assume role callback to finish before setting refresh interval
        await waitForInitialCredentialRefresh();
        await keepRefreshingCredentialsWhenNeeded();
    }

    return {
        accessKeyId: credentials.AccessKeyId,
        secretAccessKey: credentials.SecretAccessKey,
        sessionToken: credentials.SessionToken
    }
}

// // Assume role using midway web identity token to retrieve temporary credentials
async function refreshCredentials() {
    const iamRoleArn: string = getIamRoleArn()!;
    const midwayToken = await getMidwayToken();

    console.log('Getting credentials...');
    stsClient.assumeRoleWithWebIdentity({
        RoleArn: iamRoleArn,
        RoleSessionName: 'ImageGalleryUIInvokeSession',
        WebIdentityToken: midwayToken
    }, (err, data) => {
        if (err) {
            console.error('Error while retrieving temporary credentials: ', err);
            throw err;
        }

        // Store retrieved credentials for use in subsequent calls
        credentials = data.Credentials;
    });
}

// Due to asynchronous nature of function calls, this is required to avoid reading credentials
// from local storage before they are set.
async function waitForInitialCredentialRefresh() {
    while (credentials === undefined) {
        await new Promise(resolve => setTimeout(resolve, 250));
    }
}

// Keep refreshing the current temporary credentials one minute before they expire
async function keepRefreshingCredentialsWhenNeeded() {
    const expireTime = moment(credentials.Expiration);
    const now = moment();
    const refreshInterval = expireTime.diff(now) - 60000;
    setInterval(async () => await refreshCredentials(), refreshInterval);
}

async function getMidwayToken() {
    const origin = window.location.origin;
    const midwayBaseUrl = 'https://midway-auth.amazon.com/SSO/';
    const midwayParamsUrl = `?redirect_uri=${origin}&client_id=${origin}&scope=openid&response_type=id_token&nonce=mock`;
    const midwayUrl = midwayBaseUrl + midwayParamsUrl;

    console.log('Getting midway token...');
    try {
        const midwayResponse = await axios.request({
            url: midwayUrl,
            method: 'GET',
            withCredentials: true
        });

        return midwayResponse.data;
    }
    catch (e) {
        console.error('Error while retrieving midway token: ', e);
        throw e;
    }
}